import { css, styled } from 'styled-components'
import { type ProgressVariant } from '../types'

export const Pill = styled.div<{ $variant: ProgressVariant }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px 20px;
  background-color: #ffffff;
  border: 1px solid ${({ theme }) => theme.colors.grayMedium};
  border-radius: 51px;
  box-shadow:
    0 4px 7px rgba(43, 5, 20, 0.05),
    0 4px 11.5px rgba(43, 5, 20, 0.02);

  ${({ $variant }) =>
    $variant === 'fill' &&
    css`
      box-sizing: border-box;
      width: calc(100vw - 32px);
      min-width: 240px;
      gap: 12px;
      border-radius: 999px;
      line-height: 1.45;
      box-shadow:
        0 4px 14px rgba(43, 5, 20, 0.05),
        0 4px 23px rgba(43, 5, 20, 0.02);
      /* Flush with the top of the screen: notistack's top anchor puts every
         toast 20px down (its container's 14px and its wrapper's 6px padding). */
      margin-top: -20px;
    `}
`

export const Label = styled.span`
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.48px;
  text-transform: uppercase;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.primary};
`

export const Bar = styled.div<{ $variant: ProgressVariant }>`
  position: relative;
  width: 180px;
  height: 4px;

  ${({ $variant }) =>
    $variant === 'fill' &&
    css`
      flex: 1;
      width: auto;
      border-radius: 999px;
      overflow: hidden;
    `}
`

export const BarTrack = styled.div<{ $variant: ProgressVariant }>`
  position: absolute;
  inset: 0;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.colors.primary};
  opacity: ${({ $variant }) => ($variant === 'fill' ? 0.12 : 0.1)};
`

export const BarFill = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.colors.primary};
  transition: width 0.3s ease-in-out;
`
